var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import state from './state';
export var removeDuplicateFromArray = function (items) {
    var seen = {};
    return items.filter(function (item) {
        if (item == null)
            return false;
        // eslint-disable-next-line no-prototype-builtins
        return seen.hasOwnProperty(item) ? false : (seen[item] = true);
    });
};
export var getFinalNamespaceList = function (_a) {
    var ns = _a.ns, fallbackNS = _a.fallbackNS;
    return removeDuplicateFromArray(__spreadArray(__spreadArray([], (ns ? [ns] : []), true), (fallbackNS ? [fallbackNS] : []), true).flat(3)).map(function (ns) { var _a; return (_a = state.namespaceMap[ns]) !== null && _a !== void 0 ? _a : ns; });
};
// Only for mobile usage, PC will always use onLanguageHover
export var onLanguageInspect = function (e, _a) {
    var _b, _c, _d;
    var key = _a.key, namespace = _a.namespace;
    var inspectListener = (_d = (_c = (_b = window.__I18NSPECT_DEBUG__) === null || _b === void 0 ? void 0 : _b.mobile) === null || _c === void 0 ? void 0 : _c.inspector) === null || _d === void 0 ? void 0 : _d.inspect;
    inspectListener === null || inspectListener === void 0 ? void 0 : inspectListener({
        key: key,
        namespace: namespace,
        projectAndNamespace: [],
        position: {
            x: e.clientX,
            y: e.clientY,
        },
    });
};
export var storeReverseIndex = function (_a) {
    var _b;
    var key = _a.key, value = _a.value;
    try {
        if (!window.__I18NSPECT_REVERSE_INDEX__) {
            window.__I18NSPECT_REVERSE_INDEX__ = {};
        }
        if (!window.__I18NSPECT_REVERSE_INDEX__[value]) {
            window.__I18NSPECT_REVERSE_INDEX__[value] = new Set();
        }
        (_b = window.__I18NSPECT_REVERSE_INDEX__[value]) === null || _b === void 0 ? void 0 : _b.add(key);
    }
    catch (_) {
        // empty
    }
};
